export const ASSETS = 'https://cdn.drzzle.app/';
export const SITE_BUCKET = 'https://drz-websites.s3-us-west-2.amazonaws.com';
export const CUSTOM_DIVIDER = `${ASSETS}mock-images/default-images/image-divider-custom.png`;
export const PAGE_TYPES = ['page', 'template', 'draft', 'dynamic page'];
export const QUEUE_TYPES = ['page', 'template'];
export const SITE_ASSET_FOLDERS = ['_product-assets', '_droplet-assets', '_meta', '_fonts', '_favicons'];
export const DEFAULT_PROFILE_PIC = `${ASSETS}app-images/default-user-pic.png`;
export const SQUASH_DROPLET = 'Squashing a droplet is for editing purposes only. This can be helpful maneuvering complex layouts or clear up space.';



// WEBPACK FOOTER //
// ./src/constants.js